import { ServiceTypeService } from '@aca-new/app/pages/book/shared/components/products/shared/services/service-type.service';
import { EAvailablePath } from '@aca-new/app/shared/models/enums/available-path.enum';
import { EServiceTypeNumber } from '@aca-new/app/shared/models/enums/service-type-number.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BookingFeatureService {
  private readonly _myQimaBookingServiceTypes: EServiceType[] = [EServiceType.PM, EServiceType.SP, EServiceType.BRCGS, EServiceType.DUPRO, EServiceType.CLC] as const;

  private readonly _myQimaBookingPathMapping: Partial<Record<EServiceType, EAvailablePath>> = Object.freeze({
    [EServiceType.PM]: EAvailablePath.BOOK_INSPECTION_PM,
    [EServiceType.SP]: EAvailablePath.BOOK_INSPECTION_SP,
    [EServiceType.BRCGS]: EAvailablePath.BOOK_FOOD_CERTIFICATION,
    [EServiceType.DUPRO]: EAvailablePath.BOOK_INSPECTION_DUPRO,
    [EServiceType.CLC]: EAvailablePath.BOOK_INSPECTION_CLC,
  });

  public constructor(
    private readonly _appUserSettingService: AppUserSettingService,
    private readonly _serviceTypeService: ServiceTypeService
  ) {}

  // get enabled myQima booking service types from backend
  public get enabledMyQimaBookingServiceTypes(): EServiceType[] {
    const types = this._appUserSettingService.getEnabledMyQimaBookingServiceTypes();
    // fixed types that are always enabled to all users
    const fixedTypes = [EServiceTypeNumber.BRCGS, EServiceTypeNumber.PM, EServiceTypeNumber.DUPRO, EServiceTypeNumber.SC];

    return `${types},${fixedTypes.join(',')}`
      .split(',')
      .map((str: string): string => str.trim())
      .filter((str: string): boolean => str !== '')
      .filter((str: string, idx: number, arr: string[]): boolean => arr.indexOf(str) === idx) // remove duplicates
      .reduce((acc: EServiceType[], str: string): EServiceType[] => {
        // convert EServiceTypeNumber to EServiceType
        for (const [key, value] of Object.entries(EServiceTypeNumber)) {
          if (str === value && Object.keys(EServiceType).includes(key)) {
            const type = this._serviceTypeService.getServiceTypeCodeFromText(key) as EServiceType;

            acc.push(type);
            break;
          }
        }

        return acc;
      }, []);
  }

  public getAvailableMyQimaBookingPaths(): EAvailablePath[] {
    // enable all myQima booking for test account
    if (this._appUserSettingService.getIsTestCompany()) {
      return Object.values(this._myQimaBookingPathMapping);
    }

    return this.enabledMyQimaBookingServiceTypes.reduce((paths: EAvailablePath[], serviceType: EServiceType): EAvailablePath[] => {
      const path = this._myQimaBookingPathMapping[serviceType];

      if (path) {
        paths.push(path);
      }

      return paths;
    }, []);
  }

  public isEnabledMyQimaBookingServiceType(serviceType?: EServiceType): boolean {
    // enable all myQima booking for test account
    if (this._appUserSettingService.getIsTestCompany()) {
      return this._containsServiceType(this._myQimaBookingServiceTypes, serviceType);
    } else {  // eslint-disable-line
      return this._containsServiceType(this.enabledMyQimaBookingServiceTypes, serviceType);
    }
  }

  private _containsServiceType(serviceTypes: EServiceType[], serviceType?: EServiceType): boolean {
    return serviceTypes.some((type: EServiceType): boolean => type.toUpperCase() === serviceType?.toUpperCase());
  }
}
